import { useEffect } from 'react';
import { DISPLAY_LANG } from '../../../config';
import './style.css';

const paymentTitle = {
  en: "Select a Payment Method",
  ru: "Выберите способ оплаты",
  am: "Ընտրեք վճարման եղանակը"
};

const myBalanceLabel = {
  en: "My Balance",
  ru: "Мой баланс",
  am: "Իմ հաշվից"
};

export default function PaymentPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="payment-page wrapper">
      <h1>{paymentTitle[DISPLAY_LANG]}</h1>

      <div className="box-container">
        <a href="#" className="balance-content">
          <span>{myBalanceLabel[DISPLAY_LANG]}</span>
          <span>$1000</span>
        </a>

        <a href="https://wp-ast.ru/">
          <img src="/images/users/pay-visa-arca.svg" alt="visa-arca" />
        </a>

        <a href="#">
          <img src="/images/users/pay-idram.svg" alt="idram" />
        </a>
      </div>
    </div>
  )
}
